import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'James Wilson',
  role: 'Retail Trader',
  quote: "The strategies I learned from IKHANFX completely transformed my approach to trading. I've seen consistent results for the first time in my trading career.",
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80'
}, {
  id: 2,
  name: 'Sophia Martinez',
  role: 'Financial Analyst',
  quote: "The technical analysis course was exactly what I needed to take my skills to the next level. The instructors break down complex concepts in a way that's easy to understand and apply.",
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80'
}, {
  id: 3,
  name: 'Robert Taylor',
  role: 'Day Trader',
  quote: 'After struggling for years, the risk management strategies I learned here helped me achieve consistent profitability. Worth every penny of the subscription.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  const currentTestimonial = testimonials[currentIndex];
  return <section className="py-20 bg-black" data-id="element-192">
      <div className="container mx-auto px-4" data-id="element-193">
        <div className="text-center mb-16" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-195">
            What Our Members Say
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-196">
            Hear from traders who have transformed their approach with our
            expert instruction.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-197">
          <div className="bg-zinc-900 rounded-lg p-8 md:p-12 relative" data-id="element-198">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-199">
              <div className="w-32 h-32 rounded-full overflow-hidden flex-shrink-0" data-id="element-200">
                <img src={currentTestimonial.image} alt={currentTestimonial.name} className="w-full h-full object-cover" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <blockquote className="text-xl italic mb-6" data-id="element-203">
                  "{currentTestimonial.quote}"
                </blockquote>
                <div data-id="element-204">
                  <p className="font-bold text-lg" data-id="element-205">{currentTestimonial.name}</p>
                  <p className="text-gray-400" data-id="element-206">{currentTestimonial.role}</p>
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-8 space-x-4" data-id="element-207">
              <button onClick={prevTestimonial} className="p-2 rounded-full border border-white/30 hover:bg-white/10 transition-colors" aria-label="Previous testimonial" data-id="element-208">
                <ChevronLeft size={20} data-id="element-209" />
              </button>
              <button onClick={nextTestimonial} className="p-2 rounded-full border border-white/30 hover:bg-white/10 transition-colors" aria-label="Next testimonial" data-id="element-210">
                <ChevronRight size={20} data-id="element-211" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}